import {
    GET_ATTENDANCE_DASHBOARD_STATUS,
    GET_ATTENDANCE_DASHBOARD_STATUS_FAILURE,
    GET_ATTENDANCE_DASHBOARD_STATUS_SUCCESS,
} from '../../modules/constants';

const initialState = {
    isLoading: false,
    officeTypeStatus: null,
};

const attendanceDashboardReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ATTENDANCE_DASHBOARD_STATUS:
            return {
                ...state,
                isLoading: true,
            };
        case GET_ATTENDANCE_DASHBOARD_STATUS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                officeTypeStatus: action.payload.data.data,
            };
        case GET_ATTENDANCE_DASHBOARD_STATUS_FAILURE:
            return {
                ...state,
                isLoading: false,
                officeTypeStatus: null,
            };
        default:
            return state;
    }
};

export default attendanceDashboardReducer;
